export enum UNDERLYING_ASSET_TYPE {
  RATE = 'RATE',
  INDEX = 'INDEX',
}
